// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HRAS","content":"styles_content__2Azv3"};